// Invoice cache keys are dependency-free so shared keys and socket consumers use the same values.
export const invoiceKeys = {
  all: ['ap-invoices'] as const,
  list: (params?: unknown) => ['ap-invoices', 'list', params] as const,
  lists: ['ap-invoices', 'list'] as const,
  detail: (id: string) => ['ap-invoices', 'detail', id] as const,
  matchedDocuments: (id: string) => ['ap-invoices', 'matched-documents', id] as const,
  poComparison: (id: string) => ['ap-invoices', 'po-comparison', id] as const,
  comments: (id: string) => ['ap-invoices', 'comments', id] as const,
  progress: (id: string) => ['ap-invoices', 'progress', id] as const,
  taxAdjustment: (id: string, states?: readonly string[]) =>
    ['ap-invoices', 'tax-adjustment', id, states] as const,
  approvalCapabilities: (id: string) => ['ap-invoices', 'approval-capabilities', id] as const,
  automationHistory: (id: string) => ['ap-invoices', 'automation-history', id] as const,
  reviewQueues: ['ap-invoices', 'review-queues'] as const,
  operationalHealth: ['ap-invoices', 'operational-health'] as const,
  vendorInvoices: (vendorId?: unknown, params?: unknown) =>
    ['ap-invoices', 'vendor-invoices', vendorId, params] as const,
  vendor: (vendorId?: unknown) => ['ap-invoices', 'vendor', vendorId] as const,
  vendors: (params?: unknown) => ['ap-invoices', 'vendors', params] as const,
  vendorAliases: (vendorId?: unknown) => ['ap-invoices', 'vendor-aliases', vendorId] as const,
  vendorAudit: (vendorId?: unknown) => ['ap-invoices', 'vendor-audit', vendorId] as const,
  vendorMergeReviews: (vendorId?: unknown) =>
    ['ap-invoices', 'vendor-merge-reviews', vendorId] as const,
  vendorCredits: (vendorId?: unknown) => ['ap-invoices', 'vendor-credits', vendorId] as const,
}
